import React, { useEffect } from "react";
import { TextField } from "formik-mui";
import { Field, useFormikContext } from "formik";
import { useT } from "../../i18n";
import { useGetZahllauf } from "../../client/hooks";

interface ZahllaufModalProps {
  zahllaufId: string | undefined;
}

export default function ZahllaufModalFields({
  zahllaufId,
}: ZahllaufModalProps) {
  const { t: t1 } = useT("zahllauf");
  const ladeZahllauf = useGetZahllauf();
  const { setFieldValue } = useFormikContext();
  useEffect(() => {
    if (zahllaufId) {
      ladeZahllauf(zahllaufId)
        .then((zahllauf) => {
          setFieldValue("bezeichnung", zahllauf.bezeichnung);
        })
        .catch((error) => {
          console.error("Error loading zahllauf:", error);
        });
    }
  }, [zahllaufId]);
  return (
    <Field
      component={TextField}
      name="bezeichnung"
      label={t1("paymentrun")}
      fullWidth
      margin="normal"
    />
  );
}
